module.exports = __webpack_public_path__ + "static/media/55.fab7835a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/55.svg
// module id = 160
// module chunks = 0